import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';

export class AppDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }

  parse(value: any): Date | null {
    const date = moment(value, 'DD.MM.YYYY', true);
    if (!date.isValid()) {
      return null;
    }
    return date.toDate();
  }

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${this.parseDigit(day)}.${this.parseDigit(month)}.${year}`;
    }
    return super.format(date, displayFormat);
  }

  private parseDigit(n: number) {
    return ('00' + n).slice(-2);
  }
}
